export default __webpack_public_path__ + "static/media/chaussette.b3540173.jpeg";